import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authData, setAuthData] = useState({
    authtoken: null,
    userId: null,
    email: null,
    name: null,
    role: null,
    avatar: null
  });

  useEffect(() => {
    const savedAuthData = JSON.parse(localStorage.getItem('authData'));
    if (savedAuthData) {
      setAuthData(savedAuthData);
    }
  }, []);

  const createAuthData = (token, userId, email, role, name,avatar) => {
    setAuthData({
      token,
      userId,
      email,
      role,
      name,
      avatar
    });

    localStorage.setItem('authData', JSON.stringify({
      token,
      userId,
      email,
      role,
      name,
      avatar
    }));
  };

  const logout = () => {
    setAuthData({
      authtoken: null,
      userId: null,
      email: null,
      name: null,
      role: null,
      avatar: null
    });

    localStorage.removeItem('authData');
  };

  return (
    <AuthContext.Provider value={{ authData, createAuthData, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
